import { render, staticRenderFns } from "./allocateDetail.vue?vue&type=template&id=aa462f60&scoped=true"
import script from "./allocateDetail.vue?vue&type=script&lang=js"
export * from "./allocateDetail.vue?vue&type=script&lang=js"
import style0 from "./allocateDetail.vue?vue&type=style&index=0&id=aa462f60&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa462f60",
  null
  
)

export default component.exports